export default {
  header: {
    title: 'Cadeaukaart kopen',
  },
  items: {
    gift_card: {
      label: 'Cadeaukaart',
      title: 'Selecteer uw gewenste bedrag',
      description: 'Voeg de cadeaukaart met de gewenste hoeveelheid toe aan het winkelwagentje',
    },
    expiration: {
      label: '3 jaar geldig',
      title: 'Veel plezier met geven!',
      description: 'De ontvanger kan de bon flexibel binnen 3 jaar inwisselen.',
    },
    delivery: {
      label: 'Direct als PDF per e-mail geleverd',
      title: 'Directe levering als PDF per e-mail',
      description: 'Na veilige betaling via creditcard, PayPal of giropay ontvangt u de bon direct.',
    },
  },
  form: {
    value: {
      title: 'Kies het cadeaukaartbedrag',
      custom: {
        label: 'Aangepast',
        placeholder: 'Bedrag invoeren',
      },
    },
    quantity: {
      title: 'Aantal',
    },
    email: {
      title: 'Wat is uw e-mailadres zodat we u de cadeaukaart kunnen sturen?',
      placeholder: 'Uw e-mailadres',
    },
  },
  confirmation: {
    title: {
      title: 'Cadeaukaart aanmaken?',
      subtitle_one: 'Wilt u 1 cadeaukaart aanmaken voor {{value}}?',
      subtitle_other: 'Wilt u {{count}} cadeaukaarten aanmaken voor {{value}}?',
    },
    description: {
      total: 'Totaal:',
      email: 'E-mail:',
      quantity: 'Aantal',
      amount: 'Bedrag',
    },
    footer: {
      cancel: 'Annuleren',
      confirm: 'Bevestigen',
    },
  },
  buttons: {
    create: 'Aanmaken',
  },
  toasts: {
    error: 'Aanmaken van cadeaukaart mislukt.',
    success: 'Cadeaukaart succesvol aangemaakt.',
  },
};
